import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/** Zona horaria usada en toda la app (Santiago, Chile) */
export const DEFAULT_TIMEZONE = "America/Santiago";

/** Si el backend envía fechas UTC sin "Z" (ej. "2026-02-06T13:42:00"), las interpretamos como UTC. */
export function parseAsUTC(value) {
  if (value instanceof Date) return value;
  if (typeof value === "string" && value.trim()) {
    const s = value.trim();
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(s) && !/Z|[+-]\d{2}:?\d{2}$/.test(s)) {
      return new Date(s + "Z");
    }
  }
  return new Date(value);
}

export function formatClp(value) {
  return `CLP $${Number(value || 0).toLocaleString('es-CL')}`;
}

export function formatDateWithTZ(value, options = {}, locale = "es-CL") {
  const date = parseAsUTC(value);
  return new Intl.DateTimeFormat(locale, { timeZone: DEFAULT_TIMEZONE, ...options }).format(date);
}

export function formatTimeWithTZ(value, options = {}, locale = "es-CL") {
  const date = parseAsUTC(value);
  return new Intl.DateTimeFormat(locale, {
    timeZone: DEFAULT_TIMEZONE,
    hour: "2-digit",
    minute: "2-digit",
    ...options
  }).format(date);
}

export function formatDateTimeWithTZ(value, options = {}, locale = "es-CL") {
  const date = parseAsUTC(value);
  return new Intl.DateTimeFormat(locale, { timeZone: DEFAULT_TIMEZONE, ...options }).format(date);
}
